/*
 Tag Carrier include a Tag Centre that should be under cb.js,
 and L.LabelCarrier  extend from L.LinkedTag
*/
import { Tortoise } from '../../js/cb';


(function (window, document, undefined) {

L.LabelCarrier = L.LinkedTag.extend({

    initialize: function (hub, options, source_list) {
        L.LinkedTag.prototype.initialize.call(this, options);

        this._hub = hub;
        this._boardeds = [];
        if (source_list) {
            this.onboard(source_list);
        }

        this._initPosition();
        if (this._pos) {
            this._setLinePosition(this._pos);
        }
    },

    onAdd: function (map) {
        L.DivOverlay.prototype.onAdd.call(this, map);

        this._initInteraction();

        map
            .on('moveend', this._onMoveEnd, this)
            .on('viewreset', this._onViewReset, this);

        if (this._animated) {
            map.on('zoomanim', this._zoomAnimation, this);
            map.on('zoomend', this._endZoomAnimation, this);
        }

        if (L.Browser.touch && !this.options.noHide) {
            L.DomEvent.on(this._container, 'click', this.close, this);
        }

        for (var i=0; i<this._boardeds.length; i++) {
            var dock = this._boardeds[i];
            if (dock.line) {
                map.addLayer(dock.line);
            }
        }
    },

    onRemove: function (map) {
        L.DivOverlay.prototype.onRemove.call(this, map);

        for (var i=0; i<this._boardeds.length; i++) {
            var dock = this._boardeds[i];
            if (dock.line) {
                map.removeLayer(dock.line);
            }
        }

        map.off({
            zoomanim: this._zoomAnimation,
            moveend: this._onMoveEnd,
            viewreset: this._onViewReset
        }, this);

        this._removeInteraction();

        this._map = null;
    },

    _initPosition: function() {
        var lat = null, lon = null, count = 0;

        for (var i=0; i<this._boardeds.length; i++) {
            if (lat === null) lat = 0;
            if (lon === null) lon = 0;

            var _latlng = this._boardeds[i].layer.getLatLng();
            lat += _latlng.lat;
            lon += _latlng.lng;
            count ++;
        }

        if (count > 0 && lat !== null && lon !== null) {
            lat = lat / count;
            lon = lon / count;
            this.setLatLng([lat, lon]);
        }
    },

    _setLinePosition: function(pos) {
        var self = this;
        for (var i=0; i<self._boardeds.length; i++) {
            var dock = self._boardeds[i];
            self._set_layer_line(dock, pos);
        }
    },

    _set_layer_line: function(dock, pos) {
        //
        // dock = {layer, line}
        //
        var self = this;
        var _bound_pos = self._intersect_pos(dock.layer.getLatLng(), pos);
        if (!_bound_pos) {
            _bound_pos = pos;
        }

        var linkline = dock.line;
        if (!linkline) {
            linkline = dock.line =
                new L.LinkedPath(dock.layer.getLatLng(), _bound_pos);
            if (self.options.lineOptions) {
                linkline.setStyle(self.options.lineOptions);
            }
        }
        else {
            linkline.setLatLngs(dock.layer.getLatLng(), _bound_pos);
        }
        if (self._map) {
            self._map.addLayer(linkline);
        }
    },

    _onboardDock: function(dock) {
        var self = this;
        var pos = self._pos;
        if (pos) {
            self._set_layer_line(dock, pos);
        }
    },

    _offboardDock: function(dock) {
        var self = this;
        var linkline = dock.line;
        if (linkline) {
            if (self._map) {
                self._map.removeLayer(linkline);
            }
            linkline = null;
            linkline = dock.line = null;
        }
    },

    _zoomAnimation: function (opt) {
        var self = this;
        if (self._map) {
            for (var i=0; i<self._boardeds.length; i++) {
                var dock = self._boardeds[i];
                this._map.removeLayer(dock.line);
            }
        }
        var pos = self._map._latLngToNewLayerPoint(self._latlng, opt.zoom, opt.center).round();
        self._setPosition(pos);
    },

    _endZoomAnimation: function (opt) {
        var self = this;
        if (self._map) {
            for (var i=0; i<self._boardeds.length; i++) {
                var dock = self._boardeds[i];
                this._map.addLayer(dock.line);
            }
            this._setLinePosition(this._pos);
        }
    },

    onboard: function(layers) {
        var self = this;
        for (var j=0; j<layers.length; j++) {
            var layer = layers[j];
            var _has = false;
            for (var i=0; i<self._boardeds.length; i++) {
                if (self._boardeds[i].layer === layer) {
                    _has = true;
                    break;
                }
            }
            if (!_has) {
                var dock = {layer:layer, line:null};
                self._boardeds.push(dock);
                self._onboardDock(dock);
                self.remap();
            }
        }
    },

    offboard: function(layer) {
        var self = this;
        var _has_removed = false;
        for (var i=self._boardeds.length-1; i>=0; i--) {
            if (self._boardeds[i].layer === layer) {
                var dock = self._boardeds[i];
                self._offboardDock(dock);
                self._boardeds.splice(i, 1);
                dock = null;
                _has_removed = true;
                break;
            }
        }
        if (_has_removed) {
            self.remap();
        }
    },

    remap: function(force) {
        var self = this;
        if (self._boardeds.length == 0) {
            if (self._map) {
                self._hub.removeFromMap(self);
            }
        }
        else if (force || !self._map) {
            self._hub.addToMap(self);
        }
    }
});


L.LabelCarrierHub = L.Class.extend({
    options: {
        labelOptions: {}
    },

    initialize: function(map, options) {
        L.setOptions(this, options);
        this._map = map;
        this._carries = {};
        this._contents = {};
    },

    __onboard_task: function(key, layer) {
        var self = this;
        if (!self.task_holder) {
            var _task = function(params) {
                var key_pairss = [];
                for (var i=0; i<params.length; i++) {
                    var new_key = params[i].key;
                    var _has = false;
                    for (var j=0; j<key_pairss.length; j++) {
                        if (key_pairss[j].key == new_key) {
                            key_pairss[j].layers.push(params[i].layer);
                            _has = true;
                            break;
                        }
                    }
                    if (!_has) {
                        key_pairss.push({key:new_key, layers:[params[i].layer]});
                    }
                }

                for (var i=0; i<key_pairss.length; i++) {
                    var _pair = key_pairss[i];

                    var _carrie = self._carries[_pair.key];
                    if (!_carrie) {
                        var _label = self.options.label;
                        if (!_label) {
                            _label = L.LabelCarrier;
                        }
                        _carrie = self._carries[_pair.key] = new _label(self,
                            self.options.labelOptions, _pair.layers);
                        _carrie.setContent(self._contents[_pair.key]);
                        self.addToMap(_carrie);
                    }
                    else {
                        _carrie.onboard(_pair.layers);
                    }
                }
            };

            self.task_holder = new Tortoise(_task, {
                delay: 200,
                mode: "pour_out",
                count_out: 3
            });

            // _task([
            //    {key: key, layer: layer}
            // ])
        }

        self.task_holder.punch({
                key: key, layer: layer
            });

        return layer;
    },

    onboard: function(key, layer) {
        var self = this;
        return self.__onboard_task(key, layer);
    },

    offboard: function(layer) {
        var self = this;
        for (var key in self._carries) {
            var carrie = self._carries[key];
            carrie.offboard(layer);
        }

        return layer;
    },

    removeFromMap: function(label) {
        var self = this;
        for (var key in self._carries) {
            var carrie = self._carries[key];
            if (label == carrie && self._map) {
                self._map.removeLayer(carrie);
                break;
            }
        }
    },

    addToMap: function(label) {
        var self = this;
        if (self._map) {
            for (var key in self._carries) {
                var carrie = self._carries[key];
                if (label == carrie && self._map) {
                    self._map.addLayer(carrie);
                    break;
                }
            }
        }
    },

    setContent: function(key, content) {
        var self = this;

        self._contents[key] = content;
        var _carrie = self._carries[key];
        if (_carrie) {
            _carrie.setContent(content);
        }
    },

    remap: function() {
        var self = this;
        if (self._map) {
            for (var key in self._carries) {
                var carrie = self._carries[key];
                carrie.remap(true/*force to remap*/);
            }
        }
    }

});


}(this, document));



// WEBPACK FOOTER //
// ./src/assets/cb/leaflet/leaflet.label-carrier.js